import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { EMOJI, EMOJI_CATEGORIES } from "@/lib/format";

export const EmojiPicker = ({ onPick, children, align = "end", side = "top" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase().replace(/^:|:$/g, "");
    if (!s) return null;
    return Object.keys(EMOJI).filter((k) => k.includes(s)).slice(0, 72);
  }, [q]);
  const pick = (name) => { onPick(name, EMOJI[name]); setOpen(false); setQ(""); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent align={align} side={side} className="p-0 border-0 bg-transparent shadow-none w-auto" data-testid="emoji-picker">
        <div className="tc-emoji-picker tc-fade-in">
          <input className="tc-emoji-picker__search" placeholder="Search all emoji" value={q} onChange={(e) => setQ(e.target.value)} autoFocus data-testid="emoji-search-input" />
          <div className="tc-emoji-picker__grid tc-scroll">
            {filtered ? (
              filtered.length ? filtered.map((k) => <button key={k} className="tc-emoji-picker__cell" title={`:${k}:`} onClick={() => pick(k)} data-testid={`emoji-${k}`}>{EMOJI[k]}</button>) : <div className="tc-emoji-picker__cat">No emoji found</div>
            ) : (
              EMOJI_CATEGORIES.map((cat) => (
                <div key={cat.name} style={{ display: "contents" }}>
                  <div className="tc-emoji-picker__cat">{cat.name}</div>
                  {cat.keys.map((k) => <button key={`${cat.name}-${k}`} className="tc-emoji-picker__cell" title={`:${k}:`} onClick={() => pick(k)} data-testid={`emoji-${k}`}>{EMOJI[k]}</button>)}
                </div>
              ))
            )}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
